<template>
	<div class="c-DateTimeRange">
		<DateTimePicker
			class="c-DateTimeRange__input"
			:data="fromDateTime"
			:only-time="onlyTime"
			:only-date="onlyDate"
			:input-format="inputFormat"
			:field-format="fieldFormat"
			:output-format="outputFormat"
			:max-date="maxDate"
			:disabled="disabled"
			:is-active="isActive"
			:label="fromLabel"
			@change="handleDateTimeChange('from', $event)">
		</DateTimePicker>
		<DateTimePicker
			class="c-DateTimeRange__input"
			:data="toDateTime"
			:only-time="onlyTime"
			:only-date="onlyDate"
			:input-format="inputFormat"
			:field-format="fieldFormat"
			:output-format="outputFormat"
			:min-date="minDate"
			:disabled="disabled"
			:is-active="isActive"
			:label="toLabel"
			@change="handleDateTimeChange('to', $event)">
		</DateTimePicker>
	</div>
</template>

<script>
import DateTimePicker from '../DateTimePicker/DateTimePicker.vue'

export default {
	name: 'DateTimeRange',
	components: {
		DateTimePicker
	},
	props: {
		/**
     * The DateTimeRange FROM label
     */
		fromLabel: {
			type: String,
			required: true,
			default: () => ''
		},
		/**
     * The DateTimeRange TO label
     */
		toLabel: {
			type: String,
			required: true,
			default: () => ''
		},
		/**
     * The DateTimeRange data field
     */
		data: {
			type: Array,
			required: false,
			default: () => undefined
		},
		/**
     * The DateTimeRange input format (momentJS style)
     */
		inputFormat: {
			type: String,
			required: false,
			default: () => 'YYYY-MM-DDTHH:mm:ss.SSSZ'
		},
		/**
     * The DateTimeRange display format (momentJS style)
     */
		fieldFormat: {
			type: String,
			required: false,
			default: () => 'YYYY-MM-DD HH:mm'
		},
		/**
     * The DateTimeRange output format (momentJS style)
     */
		outputFormat: {
			type: String,
			required: false,
			default: () => 'YYYY-MM-DDTHH:mm:ss'
		},
		/**
     * If the DateTimeRange should be for dates only
     * @values true, false
     */
		onlyDate: {
			type: Boolean,
			required: false,
			default: () => false
		},
		/**
     * If the DateTimeRange should be for time only
     * @values true, false
     */
		onlyTime: {
			type: Boolean,
			required: false,
			default: () => false
		},
		/**
     * If the DateTimeRange is in an active state
     * @values true, false
     */
		isActive: {
			type: Boolean,
			required: false,
			default: () => false
		},
		/**
     * If the DateTimeRange is disabled
     * @values true, false
     */
		disabled: {
			type: Boolean,
			required: false,
			default: () => false
		}
	},
	data () {
		return {
			fromDateTime: undefined,
			toDateTime: undefined,
			minDate: undefined,
			maxDate: undefined
		}
	},
	watch: {
		data: {
			handler (newVal) {
				if (newVal && newVal.length === 2) {
					// eslint-disable-next-line prefer-destructuring
					this.fromDateTime = newVal[0]
					// eslint-disable-next-line prefer-destructuring
					this.toDateTime = newVal[1]
				}
			},
			immediate: true
		}
	},
	methods: {
		handleDateTimeChange (key, val) {
			if (key === 'from' && val && val.length) {
				this.minDate = val
				this.fromDateTime = val
			} else if (key === 'from' && !val) {
				this.minDate = undefined
				this.fromDateTime = undefined
			}

			if (key === 'to' && val && val.length) {
				this.maxDate = val
				this.toDateTime = val
			} else if (key === 'to' && !val) {
				this.maxDate = undefined
				this.toDateTime = undefined
			}

			/**
       * Triggers when DateTimePicker changes it's value
       * @event change
       * @property {Array} arr array with FROM and TO dates
       */
			this.$emit('change', [this.fromDateTime, this.toDateTime])
		}
	}
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
.c-DateTimeRange {
  width: 100%;
  border-radius: $border-radius;
  display: flex;
  flex: auto;

  &__input {
    width: 50%;

    &:first-child .field-input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }

    &:last-child .field-input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
